import React from 'react';
export function PokedexHeader() {
  return <div className="mb-6" data-id="element-197">
      <div className="flex items-center justify-between" data-id="element-198">
        <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-green-500 to-yellow-500 bg-clip-text text-transparent" data-id="element-199">
          Pokédex
        </h2>
        <div className="flex space-x-2" data-id="element-200">
          <div className="w-8 h-8 rounded-full bg-red-500 border-4 border-white animate-pulse" data-id="element-201"></div>
          <div className="w-8 h-8 rounded-full bg-yellow-500 border-4 border-white" data-id="element-202"></div>
          <div className="w-8 h-8 rounded-full bg-green-500 border-4 border-white" data-id="element-203"></div>
        </div>
      </div>
      <p className="text-gray-300 mt-2" data-id="element-204">
        Explore detailed information about various Pokémon, their stats, and
        more!
      </p>
    </div>;
}